import logListStore from '@/store/log/log-list-store'

export default {
  namespaced: true,
  modules: {
    list: logListStore
  }
}
